// Type-preserving functions (return same branded type as input)
/** @pure */
export const Total = <T extends number>(...values: T[]): T =>
  (values as number[]).reduce((a, b) => a + b, 0) as T

/** @pure */
export const Mean = <T extends number>(...values: T[]): T => (Total(...values) / values.length) as T

/** @pure */
export const Mult = <T extends number>(...values: T[]): T =>
  (values as number[]).reduce((a, b) => a * b, 1) as T

/** @pure */
export const Subtract = <T extends number>(a: T, b: T): T => (a - b) as T

/** @pure */
export const Divide = <T extends number>(a: T, b: T): T => (a / b) as T

/** `value` times a plain `factor`, of the same kind: a length a share of another. @pure */
export const Scale = <T extends number>(value: T, factor: number): T => (value * factor) as T
